import React from 'react';

const Contact = () => {
  return (
    <div className='container' style={{ maxWidth: '1200px'}}>
      <p className='text-light fs-4' style={{paddingTop:"8%"}}>
        <b>Have questions or need assistance?</b>
        <br />
        We're here to help! Feel free to reach out for support, feedback, or general inquiries about DocKing. Your insights are important to us as we continue to enhance our molecular docking tool for researchers and professionals.
        <br />
        <br />
        📧 Email us at: grutzmann9@gmail.com
        <br />
        <br />
        Looking forward to connecting with you!
        <br />
        <br />
      </p>
    </div>
  );
}

export default Contact;
